const BROKERAGE_FREQUENCY_CUTOFF = '2026-04-01';

export const isNewBrokerageSystem = (quotation) => quotation.emission_date == null || new Date(quotation.emission_date) >= new Date(BROKERAGE_FREQUENCY_CUTOFF);

export const getBrokeragePerPayment = (quotation) => {
  if (isNewBrokerageSystem(quotation)) {
    return quotation.brokerage_amount / quotation.payment_frequency;
  }
  return quotation.brokerage_amount;
};
